export default (text = '') => {
  let out = text.replace(/(?:\r\n|\r|\n)/g, '<br />').replace(/(<br\s*\/?>){2,}/gi, '<br>').replace(/><br \/></gi, '><');
return out;
}